import { Tabs } from 'antd';
import React from 'react'
import { ReportTapsTemplate } from '../../services';
import Template from '../../Template'

const Users = () => {

    const reasignPaths = ["/Reports/Users/Reassign/Total", "/Reports/Users/Reassign/Flow", "/Reports/Users/Reassign/Time/Days", "/Reports/Users/Reassign/Time/Hours"]
    const titels = ['Total', 'Flow', 'Days', 'Hours']
    const transitionPaths = ["/Reports/Users/Transition/Total", "/Reports/Users/Transition/Flow", "/Reports/Users/Transition/Time/Days", "/Reports/Users/Transition/Time/Hours"]
    const items = [
        {
            key: "1",
            label: `Transition`,
            children: <ReportTapsTemplate enquiryPaths={transitionPaths} enquiryTapTitels={titels} />
        },
        {
            key: "2",
            label: `Reassign`,
            children: <ReportTapsTemplate enquiryPaths={reasignPaths} enquiryTapTitels={titels} />
        }
    ];

    return (
        <Template
            headerTitle={['Reports', 'Users']}
            hasFilters={true}
        >
            <Tabs items={items} style={{ marginBottom: 70 }} />
        </Template>
    )
}

export default Users

